import { useState } from 'react';
import {
  Navbar,
  NavbarBrand,
  NavbarToggler,
  Collapse,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Container,
} from 'reactstrap';

import ContactIcons from './ContactIcons';

import "./MenuBar.css"

function MenuBar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div className='MenuBar'>
      <Navbar color="dark" dark expand="md" className="px-3">
        <NavbarBrand href="/">Kieran Stewart</NavbarBrand>
        <NavbarToggler onClick={toggle} />
        
        <Collapse isOpen={isOpen} navbar>
          <Nav className="ms-auto" navbar>
            <NavItem>
              <NavLink href="/#about">About</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/#skills">Skills</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/#projects">Projects</NavLink>
            </NavItem>
            <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret>
                Contact Me
              </DropdownToggle>
              <DropdownMenu right>
                <Container>
                  <ContactIcons />
                </Container>
              </DropdownMenu>
            </UncontrolledDropdown>
            {/* <NavItem>
              <NavLink href="/resume">Resume</NavLink>
            </NavItem> */}
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
}

export default MenuBar;